var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.localShow,
        title: _vm.title,
        icon: _vm.icon,
        "max-width": "900",
      },
      on: {
        "update:show": function ($event) {
          _vm.localShow = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "toolbar-append",
          fn: function () {
            return [
              _vm.pendingTerms.length > 0
                ? _c(
                    "v-badge",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        content: _vm.pendingTerms.length,
                        color: "warning",
                        inline: "",
                      },
                    },
                    [
                      _c("span", { staticClass: "white--text text-caption" }, [
                        _vm._v("Pendentes"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "pa-8 text-center" },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", color: "primary", size: "48" },
                }),
                _c("p", { staticClass: "mt-4 text-body-1 grey--text" }, [
                  _vm._v("Carregando seus termos..."),
                ]),
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "v-tabs",
                  {
                    staticClass: "ma-0",
                    attrs: { grow: "" },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      "v-tab",
                      [
                        _c("v-icon", { attrs: { left: "", small: "" } }, [
                          _vm._v("mdi-clock-alert-outline"),
                        ]),
                        _vm._v(" Pendentes "),
                        _vm.pendingTerms.length > 0
                          ? _c("v-badge", {
                              staticClass: "ml-2",
                              attrs: {
                                content: _vm.pendingTerms.length,
                                color: "warning",
                                inline: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "v-tab",
                      [
                        _c("v-icon", { attrs: { left: "", small: "" } }, [
                          _vm._v("mdi-check-circle-outline"),
                        ]),
                        _vm._v(" Assinados "),
                        _vm.signedTerms.length > 0
                          ? _c("v-badge", {
                              staticClass: "ml-2",
                              attrs: {
                                content: _vm.signedTerms.length,
                                color: "success",
                                inline: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
                _c(
                  "v-tabs-items",
                  {
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      "v-tab-item",
                      { key: "pending" },
                      [
                        _vm.sortedPendingTerms.length === 0
                          ? _c(
                              "div",
                              { staticClass: "pa-8 text-center" },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { size: "64", color: "success" } },
                                  [_vm._v("mdi-check-circle")]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "mt-4 text-h6 grey--text" },
                                  [_vm._v("Nenhum termo pendente!")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-body-2 grey--text text--darken-1",
                                  },
                                  [
                                    _vm._v(
                                      " Você está em dia com todos os seus documentos. "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "v-list",
                              { attrs: { "two-line": "" } },
                              [
                                _vm._l(
                                  _vm.sortedPendingTerms,
                                  function (item, index) {
                                    return [
                                      _c(
                                        "v-list-item",
                                        { key: item.id },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: item.term.is_required
                                                      ? "error"
                                                      : "grey",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.term.is_required
                                                          ? "mdi-alert-circle"
                                                          : "mdi-file-document-outline"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.term.name) +
                                                      " "
                                                  ),
                                                  item.term.is_required
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "error",
                                                            dark: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Obrigatório "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-chip",
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "grey",
                                                            outlined: "",
                                                          },
                                                        },
                                                        [_vm._v(" Opcional ")]
                                                      ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-subtitle",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [_vm._v("mdi-calendar")]
                                                  ),
                                                  _vm._v(
                                                    " Enviado em: " +
                                                      _vm._s(
                                                        _vm._f("date")(
                                                          item.created_at
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openSignForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        left: "",
                                                        small: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-file-document-edit"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" Assinar Agora "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      index < _vm.sortedPendingTerms.length - 1
                                        ? _c("v-divider", {
                                            key: "divider-" + item.id,
                                          })
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                      ],
                      1
                    ),
                    _c(
                      "v-tab-item",
                      { key: "signed" },
                      [
                        _vm.signedTerms.length === 0
                          ? _c(
                              "div",
                              { staticClass: "pa-8 text-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "64",
                                      color: "grey lighten-1",
                                    },
                                  },
                                  [_vm._v("mdi-file-document-outline")]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "mt-4 text-h6 grey--text" },
                                  [_vm._v("Nenhum termo assinado ainda")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-body-2 grey--text text--darken-1",
                                  },
                                  [
                                    _vm._v(
                                      " Quando você assinar termos, eles aparecerão aqui. "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "v-list",
                              { attrs: { "two-line": "" } },
                              [
                                _vm._l(_vm.signedTerms, function (item, index) {
                                  return [
                                    _c(
                                      "v-list-item",
                                      { key: item.id },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "success" } },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.term.name) +
                                                  " "
                                              ),
                                            ]),
                                            _c(
                                              "v-list-item-subtitle",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-calendar-check")]
                                                ),
                                                _vm._v(
                                                  " Assinado em: " +
                                                    _vm._s(
                                                      _vm._f("dateTime")(
                                                        item.teacher_signed_at ||
                                                          item.updated_at
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                item.term.is_required &&
                                                item.agree
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "ml-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              color: "success",
                                                            },
                                                          },
                                                          [_vm._v("mdi-check")]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.term.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : item.option
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "ml-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              color: "primary",
                                                            },
                                                          },
                                                          [_vm._v("mdi-check")]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.option.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                item.term_signature_status_id !==
                                                2
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ml-2 orange--text text--darken-2",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              color:
                                                                "orange darken-2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-timer-sand"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Aguardando as demais assinaturas "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "flex-row" },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    color:
                                                                      "purple",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openViewForm(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-text-box-search-outline"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Visualizar Termo"),
                                                ]),
                                              ]
                                            ),
                                            item.url_document ||
                                            item.url_signed_document
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        color:
                                                                          "primary",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.downloadPdf(
                                                                              item
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-download"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Baixar PDF"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    index < _vm.signedTerms.length - 1
                                      ? _c("v-divider", {
                                          key: "divider-signed-" + item.id,
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
      ]),
      _c("sys-register-term-signature-form", {
        attrs: {
          show: _vm.showSignForm,
          "signature-id": _vm.selectedItem.id,
          token: _vm.token,
          view: _vm.isViewMode,
          "use-teacher-auth": !_vm.token,
        },
        on: {
          "update:show": function ($event) {
            _vm.showSignForm = $event
          },
          onCompleted: _vm.onSignCompleted,
        },
      }),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.message.length,
          message: _vm.message,
          color: _vm.error ? "error" : "success",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }